import React from 'react';

const TIPS = [
    {
        icon: '📱',
        title: 'Share the QR code',
        desc: 'Guests scan the code on screen and the camera opens instantly. No app needed.',
    },
    {
        icon: '🖼️',
        title: 'Photos appear live',
        desc: 'Every photo lands on the wall the moment it is taken.',
    },
    {
        icon: '⚙️',
        title: 'Customise anytime',
        desc: 'Move your mouse to reveal the controls. Switch between Cinematic and Board mode, or open Settings.',
    },
];

export default function OnboardingOverlay({ onDismiss }) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/75 backdrop-blur-sm">
            <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full overflow-hidden">
                {/* Header */}
                <div className="bg-purple-600 px-6 py-5 text-white relative">
                    <button
                        onClick={onDismiss}
                        className="absolute top-4 right-4 text-white/50 hover:text-white transition"
                    >✕</button>
                    <div className="flex items-center gap-2 mb-1">
                        <span className="w-2 h-2 rounded-full bg-white/60 animate-pulse" />
                        <span className="text-xs font-semibold uppercase tracking-widest text-white/70">Live Photo Wall</span>
                    </div>
                    <h2 className="text-xl font-bold">Welcome to the wall!</h2>
                    <p className="text-sm text-white/80 mt-1">Everything you need to know.</p>
                </div>

                {/* Tips */}
                <div className="px-6 py-5 space-y-4">
                    {TIPS.map(({ icon, title, desc }) => (
                        <div key={title} className="flex gap-3">
                            <span className="text-2xl shrink-0 leading-none">{icon}</span>
                            <div>
                                <div className="font-semibold text-sm text-gray-900">{title}</div>
                                <div className="text-xs text-gray-500 mt-0.5 leading-snug">{desc}</div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Action */}
                <div className="px-6 pb-5">
                    <button
                        onClick={onDismiss}
                        className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-2.5 rounded-xl transition text-sm"
                    >
                        Got it, start the show!
                    </button>
                </div>
            </div>
        </div>
    );
}
